import { Endpoint, Service } from "../../const";

//Blueprint Model Actions

const endpoint = Endpoint.RequestTrial;

export const RequestTrialService = {
    Request: (data, token = "") => Service.Request.Post(endpoint, data, token),
    }
